<template>
    <div>
        <!--<div ref="loader" class="text-center">
            <div class="spinner-border text-primary m-5"
                 style="width: 3rem; height: 3rem;"
                 role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>-->
        <div ref="container">
            <table :class="tableClass" style="width: 100%" ref="table" cellspacing="0" id="datatabla">
                <thead>
                    <tr>
                        <template v-for="column in _columns">
                            <template v-if="column.visible">
                                <template v-if="isSpecialColumn(column)">
                                    <th :class="column.titleClass" v-html="column.title" :key="column.name"></th>
                                </template>
                                <th v-else :id="column.name" :class="column.titleClass" v-html="column.title"
                                    :key="column.name"></th>
                            </template>
                        </template>
                    </tr>
                </thead>
            </table>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import defaults from "./options";
import { call, validCallable } from "./util";
import { mapState } from "vuex";

export default {
    name: "DataTable",

    props: {
        actions: {
            type: Array,
            default: () => [],
        },
        //overlay:{
        //    type: Boolean,
        //    default: true,
        //},
        formatterActions: {
            type: Array,
            default: () => [],
        },

        ajax: Function,

        columns: {
            type: Array,
            required: true,
        },

        Buttons: {
            type: Number,
            default: 1,
        },

        dom: {
            type: String,
            default: defaults.dom,
        },

        initOnStart: {
            type: Boolean,
            default: true,
        },

        language: {
            type: Object,
            default: () => defaults.language,
        },

        seleccion: {
            type: Object,
            default: null,
        },

        order: Array,

        options: {
            type: Object,
            default: () => { },
        },

        params: {
            type: Object,
            default: () => { },
        },

        perPage: {
            type: Number,
            default: defaults.perPage,
        },

        responsive: {
            type: Boolean,
            default: true,
        },

        select: {
            type: String,
            default: "",
        },
        rowStyle: {
            type: String,
            default: "",
        },

        search: String,

        serverSide: {
            type: Boolean,
            default: false,
        },

        tableClass: {
            type: String,
            default: defaults.tableClass,
        },

        url: String,

        method: {
            type: String,
            default: "post",
        },

        rowClick: {
            type: Boolean,
            default: false,
        },

        rowClickFunction: Function,

        ordering: {
            type: Boolean,
            default: true,
        },

        paging: {
            type: Boolean,
            default: true,
        },
        reduce: {
            type: Function,
            default: option => option,
        },
        includeDataRow: {
            type: Boolean,
            default: false
        },
        value: {},

        searching: {
            type: Boolean,
            default: true,
        },

        lengthChange: {
            type: Boolean,
            default: true,
        },

        HSTable: {
            type: Boolean,
            default: true,
        },

        ownData: {
            type: Boolean,
            default: false,
        },

        movil: {
            type: Boolean,
            default: false,
        },

        dataProvider: {
            type: Array,
            default: () => [],
        },
        columnDefs: String,
        name: String,
        rowReorder: {
            type: Object,
            default: () => { },
        },
        pCausion: {
            type: Boolean,
            default: true,
        },
        todo: {
            type: Boolean,
            default: true,
        }
    },

    watch: {
        search(val) {
            this.dataTable.search(val).draw();
        },

        perPage(val) {
            this.dataTable.page.len(val).draw();
        },

        params: {
            handler() {
                this.$emit("input", this.select == 'single' ? null : new Array());
                this.dataTable.ajax.reload();
            },
            deep: true
        },

        dataProvider(val) {
            this.setTableData(val);
        },
        value(val) {
            if (this.isDrawing) return;
            if (!val) return;
            if (Array.isArray(val) && val.length == 0) return;
            if ((typeof val == "string" || typeof val == "number") && val == this._modelValue) return;
            if (Array.isArray(val) && Array.isArray(this._modelValue) && isEqual(val.slice().sort(), this._modelValue.slice().sort())) return;
            const self = this
            this.dataTable.rows().every(function (index) {
                const data = self.reduce(this.data());
                if ((Array.isArray(val) && val.includes(data)) || (val && val == data))
                    self.dataTable.rows(index).select()
            })
        },
    },

    data: () => ({
        _columns: [],
        dataTable: null,
        _modelValue: null,
        isDrawing: false,
        firstLoad: true,
        _columnDefs: [],
        overlay: true,
    }),

    created() {
        this.normalizeColumns();
    },

    mounted() {
        if (this.initOnStart) {
            this.init();
        }
    },

    computed: {
        ...mapState(["domain"]),
        SelectedDOM() {
            if (this.Buttons == 1) {
                return defaults.dom;
            } else {
                //console.log(":D")
                return defaults.domButtons;
            }
        },
    },
    beforeDestroy() {
        $(this.$refs.table).off();
        if (this.dataTable) {
            this.dataTable.destroy(true);
        }
        this.dataTable = null;
    },
    beforeUpdate: function () {
        this.$nextTick(() => {

        });
    },
    methods: {
        /**
         * Initialize DataTable.
         */
        init() {

            const table = $(this.$refs.table);
            const container = $(this.$refs.container);
            const loader = $(this.$refs.loader);
            const self = this;
            ///container.hide();
            //this.overlay = true;
            //if (this.columnDefs == '0') {
            //    this._columnDefs = [{
            //        targets: 0,
            //        render: $.fn.dataTable.render.moment('YYYY/MM/DD HH:mm', 'DD/MM/YYYY hh:mm a')
            //    }];
            //}
            //console.log(this.params)
            //if (this.params.nrreporte != 0)
            this.dataTable = table.DataTable(this.mergeOptions());

            //this.dataTable.on("preXhr.dt", (e, settings, data) => {
            //    if (settings.jqXHR) settings.jqXHR.abort();
            //});

            this.dataTable.on('preXhr.dt', (e, settings, data) => {
                this.isDrawing = true;
                this._modelValue = null;
                if (settings.jqXHR)
                    settings.jqXHR.abort();
            });

            this.dataTable.on("preDraw", (e) => {

                if (this.HSTable) {
                    //console.log(">Ki2")
                    //console.log("aki", document.getElementById('container'));
                    //document.getElementById('container').style.display = "none";

                    //
                    //container.hide();
                    //loader.show();
                }
            });



            table.on("click", ".dt-action", (e) => this.handleActionClick(e));
            table.on("click", ".dt-formatterAction", (e) =>
                this.handleFormatterActionClick(e)
            );

            if (this.rowClick)
                table.on("click", "tbody tr", (e) => this.handleRowClick(e));
            else if (this.select !== "") {
                table.on("click", "tbody tr.child", (e) => {
                    const el = e.currentTarget;
                    let current_row = $(el).prev();
                    if (current_row.hasClass("selected"))
                        this.dataTable.row(current_row).deselect();
                    else
                        this.dataTable.row(current_row).select();
                });
            }

            this.dataTable.on("draw", () => {
                //
                //container.hide();
                //loader.hide();


                //this.overlay = false;
                selectif: if (this.select != '') {
                    this.dataTable.rows('.selected').every(function () {
                        if (this.child())
                            this.child().addClass("selected");
                    });

                    if (!this.value) break selectif;
                    if (Array.isArray(this.value) && this.value.length == 0) break selectif;
                    if ((typeof this.value == "string" || typeof this.value == "number") && this.value == this._modelValue) break selectif;
                    if (Array.isArray(this.value) && Array.isArray(this._modelValue) && isEqual(this.value.slice().sort(), this._modelValue.slice().sort())) break selectif;

                    this.dataTable.rows().every(function (index) {
                        const data = self.reduce(this.data());
                        if ((Array.isArray(self.value) && self.value.includes(data)) || (self.value && self.value == data))
                            self.dataTable.rows(index).select();
                    });
                }
                //else if (this.rowStyle != ''){
                //    this.dataTable.rows().every(function (index) {
                //        const data = self.reduce(this.data());
                //        self.dataTable.rows(0).select();
                //    });
                //}

                this.isDrawing = false;
                if (!this.firstLoad) return;

                //setTimeout(() => {

                //    container.show();

                //}, 3000);
                this.SelectedDOM;
                this.$emit("Cancelar");
                this.$emit("registro", this.name, this.dataTable.rows().count())
                this.$emit("apiDT", this.dataTable);

            });

            //this.dataTable.on("select deselect", (e, dt, type, indexes) => {
            //    const rows = this.dataTable.rows({
            //        selected: true,
            //    });
            //    this.dataTable.rows(indexes).every(function () {
            //        if (this.child()) {
            //            if (e.type == "deselect") this.child().removeClass("selected");
            //            else this.child().addClass("selected");
            //        }
            //    });
            //    const data = rows.data().toArray();
            //    this.$emit("input", rows.count() > 0 ? data : new Array());
            //});

            this.dataTable.on('select deselect', (e, dt, type, indexes) => {
                //console.log(e);
                //console.log(dt);
                //console.log(type);
                //console.log(indexes);
                const rows = this.dataTable.rows({
                    selected: true
                });
                this.dataTable.rows(indexes).every(function () {
                    if (this.child()) {
                        if (e.type == "deselect")
                            this.child().removeClass('selected');
                        else
                            this.child().addClass('selected');
                    }
                });

                let data = rows.data().toArray();
                let reduceData = data.map(val => this.reduce(val));

                if (rows.count() > 0) {
                    data = this.select == 'single' ? data[0] : data;
                    reduceData = this.select == 'single' ? reduceData[0] : reduceData;
                    this._modelValue = reduceData;
                }
                else {
                    data = this.select == 'single' ? null : new Array();
                    reduceData = this.select == 'single' ? null : new Array();
                    this._modelValue = reduceData;
                }

                if (this.includeDataRow) this.$emit("input", { valor: reduceData, fila: data });
                else this.$emit("input", reduceData);


            });


            this.dataTable.on("responsive-resize", () => {
                this.dataTable.rows(".selected").every(function () {
                    if (this.child())
                        this.child().addClass("selected");
                });
            });

            if (this.ownData) {
                this.setTableData(this.dataProvider);
            }

            this.dataTable.on('page.dt', function () {
                //console.log("page");
                //self.dataTable.draw(false);
                // self.dataTable.columns.adjust().draw();
            });

            this.dataTable.on('length', function (e, settings, len) {
                //console.log("length");
            });
            //this.dataTable.on('length', function (e, settings, len) {
            //    //cambio de total de registro ver
            //});
            // Escuchar el evento 'processing'
            this.dataTable.on('processing', (e, settings, processing) => {
                if (!processing) {
                    this.$emit("cargando", false);
                }
            });

            //this.dataTable.on('click', 'tr', (event) => {
            //    let datos = event.currentTarget;
            //    datos.exobs = "Hlasasasa sassa";
            //    console.log(this.dataTable.row(event.currentTarget).data());
            //    this.dataTable.row(this)
            //        .data(datos)
            //    .draw();
            //});
        },

        /**
         * Get the options for DataTable.
         *
         * @return {Object}
         */
        mergeOptions() {
            const self = this;
            const options = {
                createdRow: function (row, data, dataIndex) {
                    if (self.rowStyle == 'Pendientes') {

                        $(row).css('background-color', data.color);

                        $(row).css('color', data.colorLetra);
                    } else if (self.rowStyle == 'Lideres') {
                        $(row).find('td:nth-child(2)').css('border-left-style', 'solid');
                        $(row).find('td:nth-child(2)').css('border-left-width', '4px');
                        $(row).find('td:nth-child(2)').css('border-left-color', data.ColorSarelevante);
                        $(row).find('td:nth-child(2)').attr('title', 'Relevante');
                        if (data.ws == 1) {
                            $(row).find('td:nth-child(4)').css('border-left-style', 'solid');
                            $(row).find('td:nth-child(4)').css('border-left-width', '4px');
                            $(row).find('td:nth-child(4)').css('border-left-color', data.wsColor);
                            $(row).find('td:nth-child(4)').attr('title', 'Reporte Web Service');
                        }
                        if (data.DisposicionAu == 1) {
                            $(row).find('td:nth-child(10)').css('border-left-style', 'solid');
                            $(row).find('td:nth-child(10)').css('border-left-width', '4px');
                            $(row).find('td:nth-child(10)').css('border-left-color', 'darkorange');
                        }
                    }
                    else if (dataIndex == 0 && self.rowStyle != '') {
                        if (data.Autorizacion == 'Autorizada' || data.Autorizacion == 'No es requerida' || data.Autorizacion == 'Cada quien sus Daños') {
                            $(row).css('background-color', ' rgb(0 255 28 / 60%)', ';color', '#ffffff !important');
                        }
                    }
                    else {
                        $(row).addClass("Gola" + dataIndex);
                    }
                },
                autoWidth: false,
                order: this.order,
                columns: this.dtColumns(),
                language: this.language,
                serverSide: this.serverSide,
                scrollX: !this.responsive,
                processing: true,
                renderer: "bootstrap",
                dom: this.dom,
                ordering: this.ordering,
                paging: this.paging,
                searching: this.searching,
                pageLength: this.perPage,
                lengthChange: this.lengthChange,
                deferRender: true,
                columnDefs: this._columnDefs,
                rowReorder: this.rowReorder,
                buttons: [
                    {
                        text: this.todo == true ? 'Seleccionar Todo' : 'Todo (Página actual)',
                        action: function (row, data, dataIndex) {
                            self.$emit("SeleccionTabla", 1)
                        }
                    },
                    {
                        text: this.todo == true ? 'Deseleccionar Todo' : 'Ninguno (Página actual)',
                        action: function () {
                            self.$emit("SeleccionTabla", 2)

                        }
                    },
                    {
                        text: this.todo == true ? 'Invertir' : 'Invertir (Página actual)',
                        action: function () {
                            self.$emit("SeleccionTabla", 3)
                        }
                    }
                ],
                ajax: {
                    url: this.domain.domainNameForApi + this.url,
                    contentType: 'application/json; charset=UTF-8',//"application/json",
                    type: this.method,
                    dataType: "json",
                    data: function (d) {

                        const formData = {};

                        formData["DTable"] = { ...d };
                        if (self.params !== null && typeof self.params === "object") {
                            for (let key in self.params) {
                                if (self.params.hasOwnProperty(key)) {
                                    formData[key] = self.params[key];
                                }
                            }
                        }
                        return JSON.stringify(formData);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        //console.log('jqXHR', jqXHR);
                        if (jqXHR.status == 401) {
                            Vue.swal({
                                type: "warning",
                                title: "Sesión expiro",
                                text: "Su sesión ha expirado sera redirigido al login",
                                timer: 3000,
                                allowOutsideClick: false,
                            }).then((result) => {
                                window.location.reload(true);
                            });
                        } else if (jqXHR.status == 500) {
                            Vue.swal({
                                type: "error",
                                title: "Oops...",
                                text:
                                    "Ocurrio un error inesperado en la tabla, intentelo nuevamente",
                                timer: 3000,
                            });
                        } else if (jqXHR.status == 502 || jqXHR.status == 504) {
                            Vue.swal({
                                type: "warning",
                                title: "Tiempo de espera excedido",
                                text:
                                    "La accion se ha demorado demasiado, reintente la acción deseada",
                                timer: 3000,
                            });
                        }
                        //this.$emit("Cancelar");
                    },
                },
                rowCallback: function (row, data, index) {
                    if (self.pCausion == false) {
                        if (data.PorRecuperar != "" && data.PorRecuperar != undefined) {
                            $(row).addClass('blocked-row');
                        }
                    }

                    if (data.dfvalida != null) {

                        //console.log('Si tiene dfvalida');
                        if (data.dfvalida == 1 && data.dffhpago == "") {
                            //Mostrar
                        }
                        else if (data.dfvalida == 0 && data.dffhpago != "") {
                            //Mostrar
                        }
                        else {
                            //No mostrar
                            $(row).addClass('blocked-row');
                        }
                    }

                },
            };
            if (this.select !== "" && !this.rowClick) {
                options["select"] = {
                    style: this.select,
                };
            }

            //Descomentar para que le grupo este abierto
            if (this.responsive) {
                if (!this.movil) {
                    options["responsive"] = {
                        details: {
                            display: $.fn.dataTable.Responsive.display.childRow,
                        },
                    };
                }
                else {
                    options["responsive"] = {
                        details: {
                            display: $.fn.dataTable.Responsive.display.childRowImmediate,
                        },
                    };
                }
            }
            if (this.ownData) {
                delete options.ajax;
                options.serverSide = false;
            }
            if (this.serverSide) {
                options.deferRender = false;
            }

            return { ...this.options, ...options };
        },

        /**
         * Set table data array that was loaded from somewhere else
         * This method allow for local setting of data; though, it
         * is recommended to use ajax instead of this.
         *
         * @param {Array} data   the array of data
         */
        setTableData(data) {
            if (data.constructor === Array) {
                this.dataTable
                    .clear()
                    .rows.add(data)
                    .draw();
                this.dataTable.columns.adjust();
            }
        },

        /**
         * Normalize each column object.
         */
        normalizeColumns() {
            this._columns = this.columns.map((column) => {
                let obj;

                if (typeof column === "string") {
                    obj = {
                        name: column,
                        title: this.getTitle(column),
                        titleClass: undefined,
                        render: undefined,
                        visible: true,
                    };
                } else {
                    obj = {
                        ...column,
                        name: column.name,
                        title: this.getTitle(column),
                        titleClass: column.titleClass,
                        render: column.render,
                        visible: column.visible === undefined ? true : column.visible,
                    };
                }

                if (obj.render === undefined) {
                    if (this.extractName(obj) === "__actions") {
                        obj = {
                            ...obj,
                            orderable: false,
                            searchable: false,
                            render: (...args) => this.renderActions.apply(this, args),
                        };
                    } else {
                        if (column.formatter) {
                            if (!validCallable(column.formatter)) {
                                throw new Error(
                                    `Formatter for column ${column.name
                                    } must be a function or array.`
                                );
                            }
                            obj.render = (data, type, row, meta) =>
                                call(column.formatter, [row, data, type, meta], this);
                        }
                    }
                }
                return obj;
            });
        },

        /**
         * Determine if the given column is special.
         *
         * @param  {Object} column
         * @return {Boolean}
         */
        isSpecialColumn(column) {
            return column.name.startsWith("__");
        },

        /**
         * Get column title.
         *
         * @param  {Object|String} column
         * @return {String}
         */
        getTitle(column) {
            if (typeof column === "string") {
                if (column === "__actions") {
                    return "Actions";
                }

                return this.titleCase(column);
            }

            if (column.title === undefined) {
                return this.titleCase(column.name.replace(".", " "));
            }

            return column.title;
        },

        /**
         * @param  {String} str
         * @return {String}
         */
        titleCase(str) {
            return str.replace(
                /\w+/g,
                (s) => s.charAt(0).toUpperCase() + s.substr(1).toLowerCase()
            );
        },

        /**
         * Extract column name.
         *
         * @param  {Object} column
         * @return {String}
         */
        extractName(column) {
            return column.name.split(":")[0].trim();
        },

        /**
         * Extract column args.
         *
         * @param  {Object} column
         * @return {String}
         */
        extractArgs(column) {
            return column.name.split(":")[1];
        },

        /**
         * Render column actions.
         *
         * @return {String}
         */
        renderActions(...args) {
            const html = [""]
                .concat(this.actions)
                .reduce(
                    (result, action, index) =>
                        result + this.renderAction(...[index - 1, ...args])
                );

            return `<div class="dt-buttons">${html}</div>`;
        },

        /**
         * Render a row action.
         *
         * @param  {Number} index
         * @param  {Any} data
         * @param  {String} type
         * @param  {Any} row
         * @param  {Object} meta
         * @return {String}
         */
        renderAction(index, data, type, row, meta) {
            const action = this.actions[index];

            if (action.if === false) {
                return "";
            } else if (action.if !== undefined) {
                if (!validCallable(action.if)) {
                    throw new Error("Action if must be a function or array.");
                }

                if (call(action.if, [row, data, type, meta], this) === false) {
                    return "";
                }
            }

            let tagName = "span";

            if (action.href) {
                tagName = "a";
            } else if (action.button) {
                tagName = "button";
            }

            const element = document.createElement(tagName);

            if (tagName === "button") {
                element.setAttribute("type", "button");
            } else if (tagName === "a") {
                if (action.target) {
                    element.setAttribute("target", action.target);
                }

                element.setAttribute("href", action.href ? action.href : "#");
            }

            if (action.class) {
                element.className = action.class;
            }

            element.classList.add("dt-action");

            if (action.title) {
                element.setAttribute("title", action.title);
            }

            element.dataset.actionIndex = index;

            if (action.icon) {
                const icon = document.createElement("i");
                icon.className = action.icon;
                element.appendChild(icon);
            }

            if (action.label) {
                element.appendChild(
                    document.createTextNode((action.icon ? " " : "") + action.label)
                );
            }

            if (action.render) {
                if (!validCallable(action.render)) {
                    throw new Error("Action render must be a function or array.");
                }

                const response = call(
                    action.render,
                    [element, row, data, type, meta],
                    this
                );

                if (response !== undefined) {
                    return response;
                }
            }

            return element.outerHTML;
        },

        handleActionClick(e) {
            e.stopImmediatePropagation();///
            const el = e.currentTarget;
            const action = this.actions[el.dataset.actionIndex];
            var current_row = $(el).parents("tr");
            if (current_row.hasClass("child")) {
                //Check if the current row is a child row
                current_row = current_row.prev(); //If it is, then point to the row before it (its 'parent')
            }
            const row = this.dataTable.row(current_row);

            if (el.tagName === "A") {
                return;
            }

            if (action.click) {
                if (!validCallable(action.click)) {
                    throw new Error("Action click must be a function or array.");
                }

                call(action.click, [row.data(), row], this);
            }
        },

        handleFormatterActionClick(e) {
            e.stopImmediatePropagation();
            const el = $(e.currentTarget);
            const fAction = this.formatterActions[el.attr("data-action")];
            const params = el.attr("data-params");
            var current_row = el.parents("tr");
            if (current_row.hasClass("child")) {
                //Check if the current row is a child row
                current_row = current_row.prev(); //If it is, then point to the row before it (its 'parent')
            }
            const row = this.dataTable.row(current_row);
            if (fAction!=undefined && fAction.click) {
                if (!validCallable(fAction.click)) {
                    throw new Error("Action click must be a function or array.");
                }
                call(fAction.click, [params, row.data(), row], this);
            }
        },

        handleRowClick(e) {
            e.stopImmediatePropagation();
            const el = e.currentTarget;
            var current_row = $(el);
            //console.log(current_row);
            if (!current_row.find("td.dataTables_empty").length) {
                if (current_row.hasClass("child")) {
                    //Check if the current row is a child row
                    current_row = current_row.prev(); //If it is, then point to the row before it (its 'parent')
                }
                const row = this.dataTable.row(current_row);

                if (this.rowClickFunction) {
                    if (!validCallable(this.rowClickFunction)) {
                        throw new Error("Action click must be a function or array.");
                    }
                    call(this.rowClickFunction, [row.data(), row], this);
                }
            }
        },

        /**
         * Get the columns with attributes for DataTable.
         *
         * @return {Array}
         */
        dtColumns() {
            return this._columns.map((column) => {
                const options = {};

                if (!this.isSpecialColumn(column)) {
                    options.name = column.name;
                    options.data = column.data || column.name;
                }

                return {
                    ...options,
                    render: column.render,
                    visible: column.visible,
                    orderable: column.orderable === undefined ? true : column.orderable,
                    searchable:
                        column.searchable === undefined ? true : column.searchable,
                };
            });
        },
    },
};
</script>
<style scop>
div.dataTables_wrapper div.dataTables_processing {
    background-color: #eee;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 30;
    opacity: 0.7;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
    text-align: center;
    color: #000;
    margin: 0 auto;
}

.tablaEspecial .blocked-row {
    background-color: #1649c4a1 !important;
    pointer-events: none;
    /* Aplica una opacidad a las filas bloqueadas para hacerlas más visibles */
}

.tablaPagos .blocked-row {

    pointer-events: none;
    /* Aplica una opacidad a las filas bloqueadas para hacerlas más visibles */
}


.tablaLideres td {
    font-size: small;
}

table.dataTable tbody tr.selected .dt-formatterAction {
    color: white;
}

    .tablaAcortador tr td:nth-child(3),
    .tablaAcortador ul li:nth-child(1),
    .tablaAcortador ul li:nth-child(2){
        overflow-wrap: break-word;
        word-break: break-all;
        text-overflow: ellipsis;
    }

    /*.reporteAut tr td:nth-child(0),
    .reporteAut tr td:nth-child(1),
    .reporteAut tr td:nth-child(2),
    .reporteAut tr td:nth-child(3),
    .reporteAut ul li:nth-child(0),
    .reporteAut ul li:nth-child(1),
    .reporteAut ul li:nth-child(2) {
        overflow-wrap: break-word;
        word-break: break-all;*/
        /*text-overflow: ellipsis;*/
    /*}*/

    /*@media only screen and (min-width: 350px) and (max-width: 790px)  and (max-width: 575px) {*/
        .reporteAut tr td:nth-child(0),
        .reporteAut tr td:nth-child(1),
        .reporteAut tr td:nth-child(2),
        .reporteAut tr td:nth-child(3),
        .reporteAut tr td:nth-child(4),
        .reporteAut ul li:nth-child(0),
        .reporteAut ul li:nth-child(1),
        .reporteAut ul li:nth-child(2),
        .reporteAut ul li:nth-child(3),
        .reporteAut ul li:nth-child(4) {
            overflow-wrap: break-word;
            word-break: break-all;
            /*text-overflow: ellipsis;*/
        }
    /*}*/
    .tablaAcortador tr td:nth-child(3) {
        overflow-wrap: break-word;
        word-break: break-all;

    }

    .tablaMain tr td:nth-child(0),
    .tablaMain tr td:nth-child(1) {
        overflow-wrap: break-word;
        word-break: break-all;
    }
</style>